import { getCountryCode } from './get-country-code.js';
import { getCurrency } from './get-currency.js';
import { getLanguage } from './get-language.js';
export function createBinderV1(options) {
    const { marketId, languageTag } = options.locale;
    const locale = {
        countryCode: getCountryCode(marketId),
        language: getLanguage(languageTag),
        currency: getCurrency(marketId),
    };
    return (consumerId, consumerName) => {
        options.logger.warn(`DEPRECATED: Version 1.0.0 of the locale service is deprecated. The consumer "${consumerId}"${consumerName ? ` ("${consumerName}")` : ``} should use 3.0.0 instead.`);
        return { featureService: locale };
    };
}
//# sourceMappingURL=create-binder-v1.js.map